var e = {
	feeds: {
		title: "Import from other platforms",
		description: "Add the calendar link each platform gives you. Maat polls them and blocks those dates here automatically.",
		empty: "No platforms connected yet.",
		view: "View"
	},
	feedForm: {
		platform: "Platform",
		calendarUrl: "Calendar URL (.ics)",
		addFeed: "Add feed",
		added: "Feed added",
		addFailed: "Could not add the feed"
	},
	syncStatus: {
		title: "Sync status",
		status: "Status",
		nextPoll: "Next poll",
		lastPolled: "Last polled",
		lastSuccessful: "Last successful",
		connected: "Connected",
		never: "Never",
		paused: "Paused",
		dueNow: "Due now",
		inTime: "in {{time}}",
		failures_one: "{{count}} consecutive failure",
		failures_other: "{{count}} consecutive failures"
	},
	actions: {
		title: "Actions",
		manualPoll: "Manual poll",
		deleteFeed: "Delete feed",
		noPermission: "You don’t have permission to manage this feed.",
		syncComplete: "Sync complete",
		syncFailed: "Could not sync the feed",
		feedRemoved: "Feed removed",
		removeFailed: "Could not remove the feed",
		confirmRemove: {
			title: "Remove this feed?",
			description: "Maat will stop importing dates from this platform. Existing imported blocks stay until you clear them."
		}
	},
	events: {
		title: "Imported events",
		empty: "Nothing imported from this feed yet.",
		calendarEmpty: "No imported events yet — they appear after the next successful poll.",
		calendarTitle: "Imported calendar",
		viewAll: "View all ({{count}})",
		count_one: "{{count}} event",
		count_other: "{{count}} events",
		sourceBlock: "{{source}} block",
		nights_one: "{{count}} night",
		nights_other: "{{count}} nights",
		added: "Added {{date}}",
		lastSeen: "Last seen {{date}}"
	},
	export: {
		title: "Export to other platforms",
		description: "Paste this private link into Airbnb, VRBO, or Booking.com so they block the dates already taken on Maat.",
		urlAriaLabel: "Export calendar URL",
		copyTooltip: "Copy export link",
		copied: "Export link copied",
		rotateLink: "Rotate link",
		rotated: "Export link rotated",
		rotateFailed: "Couldn't rotate the link",
		generateLink: "Generate export link",
		generateFailed: "Couldn't generate the export link",
		confirmRotate: {
			title: "Rotate export link?",
			description: "The current link stops working immediately. You'll need to paste the new link into every platform you've connected."
		}
	}
};
//#endregion
export { e as default };
